import moment from 'moment'
import filesize from 'filesize'

export const mapMimeTypeToGeneralType = (mimeType) => {
  switch (mimeType) {
  case 'image/jpeg':
    return 'image'
  case 'image/png':
    return 'image'
  case 'application/pdf':
    return 'pdf'
  case 'video/mp4':
    return 'video'
  case 'audio/mpeg':
  case 'audio/wav':
    return 'audio'
  default:
    return null
  }
}

export const readableDate = (date) => {
  // offset returns the 'reverse' offset from UTC in minutes
  const offset = new Date().getTimezoneOffset()
  const dt = date - offset * 60
  //handle ISO 8601 data formats
  if(isNaN(dt)){
    return moment(date).format('MMM DD YY h:mm a')
  }
  return moment.unix(date).format('MMM DD YY h:mm a')
}

export const readableFilesize = (size) => {
  return filesize(size, {base: 10, round: 0})
}

export const reorder = ({elements, id, direction}) => {
  elements = JSON.parse(JSON.stringify(elements))
  elements.sort((a, b) => a.order - b.order)

  let idx
  for (let i=0; i<elements.length; i++) {
    if (elements[i].id === id) {
      idx = i
    }
  }

  if (direction === 'increase') {
    if (idx < elements.length - 1) {
      const temp = elements[idx]
      elements[idx] = elements[idx + 1]
      elements[idx + 1] = temp
    }
  } else if (direction === 'decrease') {
    if (idx > 0) {
      const temp = elements[idx]
      elements[idx] = elements[idx - 1]
      elements[idx - 1] = temp
    }
  }

  for (let i=0; i<elements.length; i++) {
    elements[i].order = i
  }

  return elements
}

export const isUUID = (val) => {
  const exp = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  return exp.exec(val) !== null
}

export const prettyUrlParam = (param) => {
  param = param.replace(/\s/g,'')
  return param.replace(/[&/\\#,+()$~%.'":*?<>{}]/g,'_')
}

export const capitalizeFirstLetter = (string) => {
  if (!string) {
    return string
  }

  return string.charAt(0).toUpperCase() + string.slice(1)
}



// WEBPACK FOOTER //
// ./src/helpers/general-helpers.js